import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Timeline from './pages/Timeline';
import Sessions from './pages/Sessions';
import Speakers from './pages/Speakers';
import Partners from './pages/Partners';
import Committee from './pages/Committee';
import Contact from './pages/Contact';
import Workshops from './pages/Workshops';
import Registration from './pages/Registration';

function App() {

  return (
    <Router>
      <ScrollToTop />
      <div className="App flex flex-col min-h-screen bg-slate-50 text-slate-900 pt-[112px]">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/speakers" element={<Speakers />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/registration" element={<Registration />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
